import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherNumberingTypeId {
  SPECIFIC = 'specific',
  RANDOM = 'random',
}

export class GiftVoucherNumberingType extends Codebook<GiftVoucherNumberingTypeId> {
  static readonly SPECIFIC = new GiftVoucherNumberingType(GiftVoucherNumberingTypeId.SPECIFIC, () =>
    $t('Specific numbering'),
  )
  static readonly RANDOM = new GiftVoucherNumberingType(GiftVoucherNumberingTypeId.RANDOM, () =>
    $t('Random numbers'),
  )

  private constructor(
    public readonly value: GiftVoucherNumberingTypeId,
    public readonly label: () => string,
  ) {
    super(value)
  }
}
